module.exports = __webpack_public_path__ + "img/content-default.8c89cb3d.png";